// extracted by mini-css-extract-plugin
export default {"icon":"action-icon_icon__WIqao"};